import { render, staticRenderFns } from "./shipping-quote-analise-add-item-modal.vue?vue&type=template&id=bbc92d6e&scoped=true&lang=pug&"
import script from "./shipping-quote-analise-add-item-modal.vue?vue&type=script&lang=ts&"
export * from "./shipping-quote-analise-add-item-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc92d6e",
  null
  
)

export default component.exports